export default (context => ({
  colour: {
    formInfo: context.colour.infoLight,
    formInfoText: context.colour.infoDark,
    formError: context.colour.errorLight,
    formErrorText: context.colour.errorDark,
    formErrorBorder: context.colour.error,
    formSuccess: context.colour.successLight,
    formSuccessText: context.colour.successDark,
    formRequired: context.colour.errorDark
  }
}));